import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';  
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';

import Swal from 'sweetalert2'


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  popupInfo: any;
  cmsURL:string = "https://cms.lineclearexpress.com";
  imageURL: string;
  popupEnabled:boolean = true;
  bannerInfo: any;
  bannerObj: any;

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private spinner: NgxSpinnerService,
    private route: Router,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private viewportScroller: ViewportScroller
  ) { }

  async ngOnInit() {

    this.titleService.setTitle("Scan 2 Deliver Express Malaysia | Line Clear Express")

    const metaDesc = this.metaService.getTag('name=description'); 

    if(!metaDesc){

      this.metaService.addTags([
        {name: "description", content: "Provides nationwide courier and  integrated supply chain management solutions from warehousing, pick and pack, last mile delivery and track and trace. Customers are empowered through the Line Clear's smart Scan2Deliver technology to make end-to-end delivery using the web or app."}
    ]);
}else{

    this.metaService.updateTag(  
        {name: "description", content: "Provides nationwide courier and  integrated supply chain management solutions from warehousing, pick and pack, last mile delivery and track and trace. Customers are empowered through the Line Clear's smart Scan2Deliver technology to make end-to-end delivery using the web or app."},  
        "name=description"  
      )  
    }

    this.spinner.show();

    const popup = await this.retrieveAnnouncer()

    // console.log('data: ', popup)

    this.imageURL = this.cmsURL + popup['image_path']

    // if(popup['active'] == 1){
    //     document.getElementById("openModalButton").click();
    // }
    // dk why this appear

    const banner = await this.retrieveBanner()

    console.log('banner data: ', banner)

    this.bannerObj = banner
  }

  
  retrieveBanner(){
    return new Promise(resolve => {

        this.apiService.getBannerList().subscribe(async (res: any) => {

            this.bannerInfo = res.data;

            resolve(this.bannerInfo)

        }, error => {
            console.log('getBannerList API Failed')

        }) 
        
    });
  }


    retrieveAnnouncer(){

        return new Promise(resolve => {

            this.apiService.getAnnouncer().subscribe(async (res: any) => {

                this.popupInfo = res.data;

                resolve(this.popupInfo)

            }, error => {
                console.log('getAnnouncer API Failed')

            }) 
            
        });

    }

}
